import { Text } from 'foundations-components/components/Text';
import { useParams } from 'react-router-dom';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { UmbrellaCollectionSections } from '../collections/components/UmbrellaCollectionSections';
import { useUmbrellaCollectionSections } from '../collections/hooks/useUmbrellaCollectionSections';
import { useUmbrellaCollections } from '../collections/hooks/useUmbrellaCollections';
import { DashboardPageWithHero } from '../components/DashboardPageWithHero';
import { MarketplaceLinkParser } from '../components/MarketplaceLinkParser';
import { ProductPageHeader } from '../components/headers/ProductPageHeader';
import { useTrackUmbrellaCollectionViewedEvent } from '../hooks/useTrackUmbrellaCollectionViewedEvent';
import { jsx as _jsx } from "react/jsx-runtime";
export function UmbrellaCollectionPage() {
  const {
    collectionSlug
  } = useParams();
  const {
    getUmbrellaCollectionBySlug
  } = useUmbrellaCollections();
  const umbrellaCollection = getUmbrellaCollectionBySlug(collectionSlug);
  const {
    loading
  } = useUmbrellaCollectionSections(umbrellaCollection);
  useTrackUmbrellaCollectionViewedEvent({
    loading,
    umbrellaCollection,
    type: 'APP'
  });
  return /*#__PURE__*/_jsx(DashboardPageWithHero, {
    headerComponent: /*#__PURE__*/_jsx(ProductPageHeader, {
      pathKey: "FEATURED_COLLECTION",
      title: (umbrellaCollection === null || umbrellaCollection === void 0 ? void 0 : umbrellaCollection.title) || '',
      subtitle: umbrellaCollection !== null && umbrellaCollection !== void 0 && umbrellaCollection.description ? /*#__PURE__*/_jsx(MarketplaceLinkParser, {
        children: /*#__PURE__*/_jsx(Text, {
          color: "text-core-subtle",
          typography: "body-100",
          children: /*#__PURE__*/_jsx(SanitizedText, {
            body: umbrellaCollection.description,
            WrapperComponent: "span"
          })
        })
      }) : undefined,
      productType: "APP"
    }),
    children: /*#__PURE__*/_jsx(UmbrellaCollectionSections, {
      umbrellaCollection: umbrellaCollection
    })
  });
}